import React, { useState, createContext } from "react";

const ForwardMessageContext = createContext();

const ForwardMessageProvider = ({ children }) => {
	const [showSelectMessageCheckbox, setShowSelectMessageCheckbox] = useState(false);
	const [selectedMessages, setSelectedMessages] = useState([]);
	const [forwardMessageModalOpen, setForwardMessageModalOpen] = useState(false);
	const [isSelectionMode, setIsSelectionMode] = useState(false);
	
	return (
		<ForwardMessageContext.Provider
			value={{
				showSelectMessageCheckbox, setShowSelectMessageCheckbox,
				selectedMessages, setSelectedMessages,
				forwardMessageModalOpen, setForwardMessageModalOpen,
				isSelectionMode, setIsSelectionMode
			}}
		>
			{children}
		</ForwardMessageContext.Provider>
	);
};

export { ForwardMessageContext, ForwardMessageProvider };
